import { isBrowser } from '../util/ssr';

const ALERTBAR = 'alertbar';
const SETTINGS = 'settings';
const PAGE = 'page';

const PREVIEWS = [ALERTBAR, SETTINGS, PAGE];

/**
 * Utility to preview unpublished contentful changes via a `preview` url param
 *
 * @param {String} feature represents a feature to preview
 * @param {Boolean} isServerSide indicates if the function is being called on the server side
 * @param {String} serverSideQuery represents the query param in the url
 * @returns {Boolean}
 */
export const isPreview = (
  feature,
  isServerSide = false,
  serverSideQuery = ''
) => {
  if (!feature) {
    throw new Error('Do not send feature as an empty string');
  } else if (!PREVIEWS.includes(feature)) {
    throw new Error(
      `Contentful preview of ${feature} is not currently supported`
    );
  }

  if (isServerSide) return serverSideQuery === feature;

 //  Client side actions only
  if (!isBrowser()) return false;

  const {
    location: { search }
  } = window;

  const queryParams = new URLSearchParams(search);
  const previewAttr = queryParams.get('preview');

  return previewAttr === feature;
};

export default {};
